(() => {
  const KEY = 'famiware-wishlist-v1';
  const labels = document.getElementById('wishlist-drawer')?.dataset || {};
  const productLabel = labels.productLabel || 'Product';
  const actionLabel = (active, title) => (active ? labels.removeLabel || 'Remove __PRODUCT__ from wishlist' : labels.addLabel || 'Add __PRODUCT__ to wishlist').replace('__PRODUCT__', title || productLabel);
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };
  const write = (items) => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (error) {}
  };
  const escapeSelector = (value) => window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/"/g, '\\"');

  const sync = () => {
    const items = read();
    const ids = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('.js-wishlist-toggle').forEach((button) => {
      const active = ids.has(String(button.dataset.wishlistId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', actionLabel(active, button.dataset.wishlistTitle));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
    render(items);
  };

  const render = (items) => {
    const container = document.querySelector('[data-wishlist-items]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!container || !empty) return;
    container.replaceChildren();
    empty.hidden = items.length > 0;
    items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'wishlist-item';

      const link = document.createElement('a');
      link.href = item.url || '#';
      if (item.image) {
        const image = document.createElement('img');
        image.className = 'wishlist-item__image';
        image.src = item.image;
        image.alt = item.title || '';
        image.loading = 'lazy';
        link.appendChild(image);
      }

      const info = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'wishlist-item__title';
      title.href = item.url || '#';
      title.textContent = item.title || productLabel;
      const price = document.createElement('span');
      price.className = 'wishlist-item__price';
      price.textContent = item.price || '';
      info.append(title, price);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-item__remove';
      remove.dataset.wishlistRemove = item.id;
      remove.setAttribute('aria-label', actionLabel(true, item.title));
      remove.textContent = '×';

      row.append(link, info, remove);
      container.appendChild(row);
    });
  };

  let drawerOpener;
  const openDrawer = () => {
    const drawer = document.getElementById('wishlist-drawer');
    const overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer || !overlay) return;
    drawerOpener = document.activeElement;
    drawer.inert = false;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-open');
    requestAnimationFrame(() => drawer.querySelector('.js-wishlist-close')?.focus());
    document.querySelectorAll('.js-wishlist-open').forEach((button) => button.setAttribute('aria-expanded', 'true'));
  };

  const closeDrawer = () => {
    const drawer = document.getElementById('wishlist-drawer');
    const overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer || !overlay) return;
    if (drawer.getAttribute('aria-hidden') === 'true') return;
    drawerOpener?.focus();
    drawer.inert = true;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-open');
    document.querySelectorAll('.js-wishlist-open').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 280);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.js-wishlist-toggle');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const id = String(toggle.dataset.wishlistId || '');
      if (!id) return;
      const items = read();
      const index = items.findIndex((item) => String(item.id) === id);
      if (index >= 0) items.splice(index, 1);
      else items.unshift({
        id,
        title: toggle.dataset.wishlistTitle || '',
        url: toggle.dataset.wishlistUrl || '',
        image: toggle.dataset.wishlistImage || '',
        price: toggle.dataset.wishlistPrice || ''
      });
      write(items);
      sync();
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const id = String(remove.dataset.wishlistRemove || '');
      write(read().filter((item) => String(item.id) !== id));
      sync();
      return;
    }

    if (event.target.closest('.js-wishlist-open')) openDrawer();
    if (event.target.closest('.js-wishlist-close')) closeDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
    const drawer = document.getElementById('wishlist-drawer');
    if (event.key === 'Tab' && drawer?.getAttribute('aria-hidden') === 'false') {
      const focusable = [...drawer.querySelectorAll('button, a[href], input, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('storage', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();

